import dayjs from "dayjs"

export function setLocalStorageTokens(tokens: any) {
  localStorage.setItem("access_token", tokens);
  }

export function setLocalStoragePermissions(permissions: any) {
  const permissionsString = JSON.stringify(permissions);
  localStorage.setItem("permissions", permissionsString);
}

export const setLocalStorageIsManager = (is_manager: boolean) => {
  localStorage.setItem("is_manager", JSON.stringify(is_manager));
};

export const getLocalStorageIsManager = (): boolean => {
  const is_manager = localStorage.getItem("is_manager");
  return is_manager ? JSON.parse(is_manager) : false;
};
export const setLocalStorageIsClientUser = (is_clientUser: boolean) => {
  localStorage.setItem("is_clientUser", JSON.stringify(is_clientUser));
};
export const getLocalStorageIsClientUser = (): boolean => {
  const is_clientUser = localStorage.getItem("is_clientUser");
  return is_clientUser ? JSON.parse(is_clientUser) : false;
};
export function getLocalStorageTokens() {
  const localTokens = localStorage.getItem("access_token");
  if (localTokens) {
    return localTokens;
  }
  return "";
}

export function getLocalStoragePermissions(): UserPermissionType[] {
  try {
    const localPermissions = localStorage.getItem("permissions");
    if (localPermissions) {
      return JSON.parse(localPermissions);
    }
    return [];
  } catch(e) {
    return [];
  }
}

export function authHeader() {
  const accessToken= getLocalStorageTokens();
  const currentUrl = window.location.pathname;
  if (accessToken && !currentUrl.includes('/auth/')) {
    return { Authorization: `Token ${accessToken}` };   
  } else {
    return {};
  }
}

export function filterRoutesByPermissions(routes: RoutesType[], userPermissions:UserPermissionType[], skipPermissionCheck: boolean = false) {
  
  // If skipPermissionCheck is true, return all routes without filtering
  if (skipPermissionCheck) {
    return routes;
  }
  
  if(!userPermissions || userPermissions.length < 1)
  {
    return routes;
  }

  return routes.filter((route) => {
    if (route.excludePermissions && route.excludePermissions.length > 0) {
      const hasExcludePermission = userPermissions.some((perm) => 
        route.excludePermissions!.includes(perm)
      );
      if (hasExcludePermission) {
        return false;
      }
    }
    
    if (!route.permissions || route.permissions.length === 0) {
      return true;
    }
    return userPermissions.some((perm) => route.permissions!.includes(perm));
  });
}

export function logout() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("permissions");
  window.location.href = '/auth/sign-in';
}

export function formatAmount(num: number) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'PKR',
    minimumFractionDigits: 0,
  });

  return formatter.format(num);
}

export function formatNumber(num: number) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
  });
  return formatter.format(num);
}



export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  const date = new Date(dateString);
  return date.toLocaleDateString(undefined, options);
};

export const getMonday = (d: Date) => {
  const date = new Date(d)
  const day = date.getDay()
  const diff = date.getDate() - day + (day === 0 ? -6 : 1)
  return new Date(date.setDate(diff))
};

export const getSunday = (monday: Date) => {
  return dayjs(monday).add(6, "day").toDate()
};

export const getFirstDayOfMonth = (d: Date) => {
  return new Date(d.getFullYear(), d.getMonth(), 1)
};

export const getLastDayOfMonth = (d: Date) => {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0)
};